<template>
  <div class="gm-form-canvas" :style="fontStyle">
    <form class="gm-form-card" :style="cardStyle" @submit.prevent="submit">
      <h2 v-if="design.heading">{{ design.heading }}</h2>
      <p v-if="design.description" class="gm-form-description">
        {{ design.description }}
      </p>
      <div class="gm-form-grid">
        <div
          v-for="(field, index) in fields"
          v-show="field.type !== 'hidden'"
          :key="field.key"
          class="gm-form-field"
          :class="[
            'gm-width-' + field.width,
            {
              'is-selected': editable && selected === index,
              'is-editable': editable
            }
          ]"
          :role="editable ? 'button' : null"
          :tabindex="editable ? 0 : null"
          :aria-label="editable ? 'Edit ' + field.label : null"
          @click="choose(index)"
          @keydown.enter.prevent="choose(index)"
          @keydown.space="selectOnSpace($event, index)"
        >
          <label
            v-if="field.type === 'checkbox' || field.type === 'consent'"
            class="gm-check"
          >
            <input
              v-model="values[field.key]"
              type="checkbox"
              :required="interactive && field.required"
              :disabled="!interactive"
              :name="field.key"
              :style="{ accentColor: design.accentColor }"
            />
            <span>{{ field.label }}{{ field.required ? ' *' : '' }}</span>
          </label>
          <label v-else>
            <span
              :class="{ 'gm-visually-hidden': design.labelStyle === 'hidden' }"
              >{{ field.label }}{{ field.required ? ' *' : '' }}</span
            >
            <textarea
              v-if="field.type === 'textarea'"
              v-model="values[field.key]"
              :placeholder="field.placeholder"
              :required="interactive && field.required"
              :disabled="!interactive"
              :name="field.key"
              rows="3"
            />
            <select
              v-else-if="field.type === 'select'"
              v-model="values[field.key]"
              :required="interactive && field.required"
              :disabled="!interactive"
              :name="field.key"
              ><option value="">{{
                field.placeholder || 'Select an option'
              }}</option
              ><option
                v-for="option in field.options"
                :key="option"
                :value="option"
                >{{ option }}</option
              ></select
            >
            <input
              v-else
              v-model="values[field.key]"
              :type="field.type === 'phone' ? 'tel' : field.type"
              :placeholder="field.placeholder"
              :required="interactive && field.required"
              :disabled="!interactive"
              :name="field.key"
            />
          </label>
        </div>
        <button
          class="gm-form-submit"
          :class="'gm-width-' + design.submitWidth"
          :style="submitStyle"
          :type="interactive ? 'submit' : 'button'"
          :disabled="busy || (!interactive && !editable)"
          @click="!interactive && $emit('select-submit')"
        >
          <span
            v-if="
              design.submitIcon !== 'none' &&
                design.submitIconPosition === 'left'
            "
            aria-hidden="true"
            >{{ icon }}</span
          >
          {{ busy ? 'Submitting…' : design.submitLabel }}
          <span
            v-if="
              design.submitIcon !== 'none' &&
                design.submitIconPosition === 'right'
            "
            aria-hidden="true"
            >{{ icon }}</span
          >
          <small v-if="design.submitSublabel">{{
            design.submitSublabel
          }}</small>
        </button>
      </div>
      <label v-if="interactive" class="gm-visually-hidden" aria-hidden="true"
        >Leave this field empty<input
          v-model="website"
          type="text"
          name="website"
          tabindex="-1"
          autocomplete="off"
      /></label>
    </form>
    <div v-if="design.footerText" class="gm-form-footer">
      {{ design.footerText }}
    </div>
  </div>
</template>
<script>
import { formFontStack } from './data/form-design';
export default {
  props: {
    design: { type: Object, required: true },
    fields: { type: Array, required: true },
    interactive: Boolean,
    editable: Boolean,
    selected: Number,
    busy: Boolean
  },
  data: () => ({ values: {}, website: '' }),
  computed: {
    fontStyle() {
      return { fontFamily: formFontStack(this.design.fontFamily) || 'inherit' };
    },
    cardStyle() {
      return {
        backgroundColor: this.design.backgroundColor || 'var(--gs-surface)',
        borderRadius:
          this.design.radius === 'md'
            ? 'var(--gs-radius-sm)'
            : 'var(--gs-radius-lg)'
      };
    },
    submitStyle() {
      return {
        backgroundColor: this.design.submitColor || this.design.accentColor,
        color: this.design.submitTextColor,
        minHeight: { sm: '36px', md: '44px', lg: '56px' }[
          this.design.submitHeight
        ]
      };
    },
    icon() {
      return (
        {
          arrow: '→',
          send: '➤',
          mail: '✉',
          calendar: '▦',
          download: '↓',
          sparkles: '✦',
          gift: '◇'
        }[this.design.submitIcon] || ''
      );
    }
  },
  methods: {
    choose(index) {
      if (this.editable) this.$emit('select', index);
    },
    selectOnSpace(event, index) {
      if (this.editable) {
        event.preventDefault();
        this.choose(index);
      }
    },
    submit() {
      if (this.interactive && !this.busy)
        this.$emit(
          'submit',
          Object.assign({}, this.values, { website: this.website })
        );
    }
  }
};
</script>
